App.namespace.wrap('views.cabinet.tooltips', () => {
  let $tooltipOwners = $('[data-toggle="cabinet-tooltip"]');

  $tooltipOwners.off('hover');
  $tooltipOwners.hover(function() {
    // Hide all tooltips
    $('.js-cabinet-tooltips').addClass('hidden');

    const tooltipContainer = $('.tooltip-container').first();
    const triggerElement = $(this);
    const triggeredTooltipElement = $(triggerElement.attr('data-tooltip-trigger'));
    const alignTo = $(`[data-tooltip-align="${triggerElement.attr('data-tooltip-trigger')}"]`);
    const baseOffset = 40;

    const container = alignTo.length ? alignTo : triggerElement;

    let marginTop = container.offset().top;
    if (tooltipContainer.length) {
      marginTop -= tooltipContainer.offset().top;
    }
    marginTop += baseOffset;

    triggeredTooltipElement.css('margin-top', marginTop);
    triggeredTooltipElement.removeClass('hidden');
  });
});
